import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { HiOutlineInformationCircle } from 'react-icons/hi'
import { TiWarningOutline } from 'react-icons/ti'
import { VscError } from 'react-icons/vsc'
import { TAlertLevel } from 'shared/types'
import { FaRegQuestionCircle } from 'react-icons/fa'
import { StatusBadge } from 'components/common/StatusBadge'

export const getAlertLevel = (level?: TAlertLevel) => {
  switch (level) {
    case 'Critical':
      return [VscError, 'red'] as const
    case 'Info':
      return [HiOutlineInformationCircle, 'blue'] as const
    case 'Warning':
      return [TiWarningOutline, 'yellow'] as const
    default:
      return [FaRegQuestionCircle, 'gray'] as const
  }
}

export const AlertLevelBadge = ({ level }: { level?: TAlertLevel }) => {
  const { t } = useTranslation()
  const [Icon, color] = useMemo(() => getAlertLevel(level), [level])

  return (
    <StatusBadge color={color} icon={<Icon />}>
      {t(`alert.${level}`)}
    </StatusBadge>
  )
}
